import { Route } from '@angular/router';
import { NotFoundComponent } from './features/main/not-found/not-found.component';
import { AppLayoutComponent } from './features/main/app-layout/app-layout.component';
import { AppTranslationsGuard } from './features/main/app-translations.guard';
import { AppEstablishmentGuardService } from './app-establishment.guard';
import establishmentRoutes from './features/establishment/establishment.routes';
import { SubsidiariesComponent } from './features/establishment/subsidiaries/subsidiaries.component';
import {
  catalogGuardFn,
  subsidiariesGroupsGuardFn,
  subsidiariesGuardFn,
} from './features/establishment/subsidiaries/subsidiaries.guard';
import { SubsidiariesGroupComponent } from './features/establishment/subsidiaries-group/subsidiaries-group.component';

export const appRoutes: Route[] = [
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'payment-issue',
    loadComponent: () =>
      import('./features/main/payment-issue/payment-issue.component').then(
        m => m.PaymentIssueComponent,
      ),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AppTranslationsGuard, AppEstablishmentGuardService],
    children: [
      {
        path: 'sucursales',
        canActivate: [subsidiariesGuardFn],
        component: SubsidiariesComponent,
      },
      {
        path: 'sucursales/grupos',
        canActivate: [subsidiariesGroupsGuardFn],
        component: SubsidiariesGroupComponent,
      },
      {
        path: 'pedido',
        loadChildren: () => import('./features/order-checkout/order-checkout.routes'),
        data: { preloadName: 'order-checkout' },
      },
      {
        path: 'pagos',
        loadChildren: () => import('./features/payments/payments.routes'),
      },
      {
        path: 'envio',
        loadChildren: () => import('./features/shipping/shipping.routes'),
      },
      {
        path: '',
        canActivate: [catalogGuardFn],
        loadChildren: () => establishmentRoutes,
      },
      // --- Catch All ---
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
